export const TYPES = {
  SINGLE: 'single_choice',
  MULTIPLE: 'multiple_choice',
  TEXT_SHORT: 'text_question_short',
  TEXT_LONG: 'text_question_long',
  DATE: 'date_question',
  RANGE: 'range_question',
  INFO: 'text'
}

export const STATUSES = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  DRAFT: 'draft',
}
